import axios from 'axios';
import { ROWS_PER_PAGE } from '../constants/config';

const API_BASE = process.env.REACT_APP_API_URL;

export const fetchPatients = (page) => {
  return axios.get(`${API_BASE}/dentdocs?page=${page}&limit=20`);
};

export const fetchSingleAuswertungen = async (rows) => {
  const token = localStorage.getItem("token");

  const keys = Array.isArray(rows)
  ? rows.map(r => ({ patnr_id: r.patnr_id, time: r.time }))
  : [{ patnr_id: rows.patnr_id, time: rows.time }];

  return axios.post(`${API_BASE}/api/doks-auswertung/by-keys`, keys , {
    headers: {
      Authorization: `Bearer ${token}`
    }
  });
};

export const streamSearchAuswertungen = async (search, onRow, onDone) => {
  const token = localStorage.getItem("token");

  const response = await fetch(`${API_BASE}/api/llm-analysis-result/search-stream?search=${encodeURIComponent(search)}`, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  });

  const reader = response.body.getReader();
  const decoder = new TextDecoder("utf-8");
  let buffer = '';
  let count = 0;

  while (true) {
    const { done, value } = await reader.read();
    if (done) break;

    buffer += decoder.decode(value, { stream: true });
    let lines = buffer.split('\n');

    // Keep incomplete line in buffer
    buffer = lines.pop();

    for (const line of lines) {
      if (!line.trim()) continue;
      try {
        const parsed = JSON.parse(line);
        count++;
        onRow(parsed, count);
      } catch (err) {
        console.error("❌ Failed to parse streamed row:", err);
      }
    }
  }

  if (onDone) onDone();
};


export const sendToProvider = async (message, provider) => {
  const start = Date.now();

  try {
    const response = await axios.post(
      'http://localhost:8030/api/chat',
      { message, provider },
      { timeout: 120000 }
    );

    return {
      text: response.data.response || 'No response',
      elapsed: ((Date.now() - start) / 1000),
      error: false,
    };
  } catch (error) {
    console.error(`❌ Error from provider "${provider}":`, error);
    return {
      text: `Error from ${provider}`,
      elapsed: ((Date.now() - start) / 1000),
      error: true,
    };
  }
};

export const fetchAnalysisCounts = async () => {
  const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/analysis_counts`, {
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
  });
  return response.data;
};

export const fetchTopTitles = async () => {
  const token = localStorage.getItem('token');
  const res = await axios.get(
    `${process.env.REACT_APP_API_URL}/top_titles`,
    {
      headers: { Authorization: `Bearer ${token}` },
    }
  );
  return res.data;
};

export const fetchTopTreatmentSteps = async () => {
  const token = localStorage.getItem('token');
  const res = await axios.get(
    `${process.env.REACT_APP_API_URL}/top_treatment_steps`,
    {
      headers: { Authorization: `Bearer ${token}` },
    }
  );
  return res.data;
};

function getIdFromQuery() {
  try {
    const qs = new URLSearchParams(window.location.search);
    const id = qs.get('id');
    if (id && /^\d+$/.test(id)) return parseInt(id, 10);
  } catch {}
  return undefined;
}

const toIsoOrNull = (t) => {
  if (!t) return null;
  const d = new Date(t);
  if (isNaN(d.getTime())) {
    return null;
  }
  return d.toISOString();
};

export const fetchAnalysisResult = async (limit, offset, search = '', title = '', filters = {}, treatment_steps = '', axiosConfig = {}) => {
  const idFromQuery = getIdFromQuery();
  const token = localStorage.getItem("token");
  const slim = (arr = []) =>
    arr.map(({ patnr_id, time }) => ({
      patnr_id: patnr_id ?? null,
      time: time ?? null,
    }));
  const body = {
    limit,
    offset,
    search: (search || '').trim(),
    title: (title || '').trim(),
    treatment_steps: (treatment_steps || '').trim(),
    showFullyAnalyzed: typeof filters.showFullyAnalyzed === 'boolean' ? filters.showFullyAnalyzed : true,
    showPartiallyAnalyzed: typeof filters.showPartiallyAnalyzed === 'boolean' ? filters.showPartiallyAnalyzed : true,
    fullyRows: Array.isArray(filters.fullyRows) ? slim(filters.fullyRows) : [],
    partiallyRows: Array.isArray(filters.partiallyRows) ? slim(filters.partiallyRows) : []
  };
  if (idFromQuery !== undefined) {
    body.id = idFromQuery;
  }
  return axios.post(
    `${API_BASE}/api/llm-analysis-result`,
    body,
    {
      ...axiosConfig,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
        ...(axiosConfig.headers || {}),
      },
    }
  );
};

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:8000',
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});